import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';
import { useTable } from 'react-table';
import { Form } from 'react-bootstrap';
import { get_all_projectcategories_logs } from '../api/projectCategoriesApi';


function AllProjectCategoriesLogs() {
    const location = useLocation();
    const projectId = (location.state as { projectId?: number })?.projectId;
    const { data, isLoading, error } = useQuery(['get_all_projectcategories_logs', projectId], () =>
        get_all_projectcategories_logs(projectId || 0), {refetchOnWindowFocus: false, enabled: projectId !== undefined && projectId !== null}
      );
      const [categoryLogs, setCategoryLogs] = useState<object[]>([]);
      const [currentPage, setCurrentPage] = useState(1);
      const [logsPerPage, setLogsPerPage] = useState(50);
      const [currentLogs, setCurrentLogs] = useState<object[]>([]);
    
      useEffect(() => {
        if (data) {
          setCategoryLogs(data.data);
        }
      }, [data]);
    
      const indexOfLastLog = currentPage * logsPerPage;
      const indexOfFirstLog = indexOfLastLog - logsPerPage;
      useEffect(() => {
        if (categoryLogs.length > 0) {
          setCurrentLogs(
            categoryLogs.slice(indexOfFirstLog, indexOfLastLog)
          )
        }
      }, [categoryLogs, indexOfFirstLog, indexOfLastLog]);
      const handlePageChange = (pageNumber: number) => setCurrentPage(pageNumber);
      const totalPages = Math.ceil(categoryLogs.length / logsPerPage);
      const getPageNumbers = (): Array<number | string> => {
        const pageNumbers: Array<number | string> = [];
        const totalPageDisplay = 5;
        let startPage = Math.max(1, currentPage - Math.floor(totalPageDisplay / 2));
        let endPage = startPage + totalPageDisplay - 1;
        if (endPage > totalPages) {
          endPage = totalPages;
          startPage = Math.max(1, endPage - totalPageDisplay + 1);
        }
        for (let i = startPage; i <= endPage; i++) {
          pageNumbers.push(i);
        }
        if (startPage > 1) {
          pageNumbers.unshift('...');
        }
        if (endPage < totalPages) {
          pageNumbers.push('...');
        }
        return pageNumbers;
      };
      if (isLoading) {
        return (
          <div className='text-center'>
            <div className='spinner-border' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>
        );
      }
      if (error) {
        return (
          <div className='text-center'>
            <h2>No Logs Found</h2>
          </div>
        );
      }
  // Show message if projectId is not provided or is 0
  if (projectId === undefined || projectId === null || projectId === 0) {
    return (
      <div className="text-center fw-bold fs-4 text-muted py-10">
        <p>Please select a project to view category logs.</p>
        <p className="fs-6 text-muted">Navigate from a project detail page to view logs for that project's categories.</p>
      </div>
    );
  }

  // ✅ Safe check before rendering anything
  if (!Array.isArray(categoryLogs) || categoryLogs.length === 0 || categoryLogs.some(log => Object.keys(log).length === 0)) {
    return (
      <div className="text-center fw-bold fs-4 text-muted">
        No records found!
      </div>
    );
  }
      const columns = [
        {
          Header: "#",
          accessor: "logsDetails.id",
          width: 50,
        },
        {
          Header: "Description",
          accessor: "logsDetails.description",
          width: 300,
          Cell: ({ row }) => (
            <>
              {Object.entries(row.original.properties.new).length > 0 ||
              Object.entries(row.original.properties.old).length > 0 ? (
                <>
                  {row.original.logsDetails.description.split("-").pop() === "updated" ? (
                    <strong>{row.original.full_name}</strong>
                  ) : row.original.logsDetails.description.split("-").pop() === "created" ? (
                    <strong>{row.original.full_name}</strong>
                  ) : row.original.logsDetails.description.split("-").pop() === "deleted" ? (
                    <strong>{row.original.full_name}</strong>
                  ) : null}
                  {row.original.logsDetails.description.split("-").pop() === "updated" ? (
                    <>
                      {row.original.userName} Made the following changes in&nbsp;
                      <strong>{row.original.logsDetails.subject_type}</strong>{" "}
                      of&nbsp;                 
                        <strong>{row.original.dataModel_name}</strong>{" "}                  
                      at{" "}
                      {row.original.logsDetails.created_at}
                    </>
                  ) : row.original.logsDetails.description.split("-").pop() === "created" ? (
                    <>
                      {row.original.userName} Added the following information in&nbsp;
                      <strong>{row.original.logsDetails.subject_type}</strong>{" "}
                      of&nbsp;
                        <strong>{row.original.dataModel_name}</strong>{" "}
                      at{" "}
                      {row.original.logsDetails.created_at}
                    </>
                  ) : row.original.logsDetails.description.split("-").pop() === "deleted" ? (
                    <>
                      {row.original.userName} Deleted the following information in&nbsp;
                      <strong>{row.original.logsDetails.subject_type}</strong>{" "}
                      of&nbsp;
                        <strong>{row.original.dataModel_name}</strong>{" "}
                      at{" "}
                      {row.original.logsDetails.created_at}
                    </>
                  ) : null}
                </>
              ) : (
                <>{row.original.logsDetails.description}</>
              )}
            </>
          ),
        },
        {
          Header: "Changes",
          accessor: "properties",
          Cell: ({ row }) => (
            <>
              <div className="table w-55">
                <table className="table table-rounded table-striped border gy-7 gs-7 align-middle">
                <thead className="border border-1 border-white">
                    <tr>
                      <th scope="col" className=" ps-5 fw-bold">
                        Column
                      </th>
                      <th scope="col" className=" ps-5 fw-bold">
                        Old
                      </th>
                      <th scope="col" className=" ps-5 fw-bold">
                        New
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(row.original.properties.new).map((key: string) => {
                      let oldValue = row.original.properties.old[key];
                      let newValue = row.original.properties.new[key];
                      // Handle "status" field with Active/Inactive display
                      if (key.toLowerCase() === "status") {
                        oldValue = oldValue === 1 ? "Active" : oldValue === 0 ? "Inactive" : oldValue;
                        newValue = newValue === 1 ? "Active" : newValue === 0 ? "Inactive" : newValue;
                      }
                      if (oldValue !== newValue || (oldValue && !newValue)) {
                        return (
                          <tr className="fs-6 text-gray-800 border border-gray-200" key={key}>
                            <td>{key}</td>
                            <td>{oldValue !== undefined ? oldValue : ""}</td>
                            <td>{newValue !== undefined ? newValue : ""}</td>
                          </tr>
                        );
                      }
                      return null;
                    })}
                    {Object.keys(row.original.properties.old).map((key: string) => {
                      if (!(key in row.original.properties.new)) {
                        const oldValue = row.original.properties.old[key];
                        return (
                          <tr className="fs-6 text-gray-800 border border-gray-200" key={key}>
                            <td>{key}</td>
                            <td>{oldValue !== undefined ? oldValue : ""}</td>
                            <td></td>
                          </tr>
                        );
                      }
                      return null;
                    })}
                  </tbody>
                </table>
              </div>
            </>
          ),
        },
      ];
      
      const Table = ({ columns, data }) => {
        const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
          useTable({
            columns,
            data,
          });

        return (
          <table
            {...getTableProps()}
            className="table table-rounded table-bordered gy-7 gs-7 border-gray-200 align-middle"
          >
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr
                  className="fs-6 text-gray-800 border border-gray-200"
                  {...headerGroup.getHeaderGroupProps()}
                >
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps()}
                      style={{ width: column.width }}
                      className="  fw-bold"
                    >
                      {column.render('Header')}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => (
                      <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        );
      };
      
      return (
        <>
          <div className='card card-xxl-stretch mx-4 mb-5 mb-xl-10'>
            <div className='card-header border-0 pt-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>Logs of All Project Categories</span>
              </h3>
            </div>
            <div className='card-body py-3'>
              <Table columns={columns} data={currentLogs} />
              <div>
                <p className="text-muted">
                  Showing {indexOfFirstLog + 1} to{' '}
                  {indexOfLastLog > categoryLogs.length ? categoryLogs.length : indexOfLastLog}{' '}
                  of {categoryLogs.length} entries
                </p>
              </div>
              <div className="mb-3 d-flex justify-content-around align-items-center">
                <div className="mb-3 d-flex justify-content-between align-items-center w-25">
                  <label htmlFor="logsPerPage" className="form-label">
                    Results Per Page
                  </label>
                  <Form.Control
                    as="select"
                    id="logsPerPage"
                    className="form-select form-select-sm w-50"
                    value={logsPerPage}
                    onChange={(e) => {
                      setLogsPerPage(Number(e.target.value));
                      setCurrentPage(1);
                    }}
                  >
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={500}>500</option>
                  </Form.Control>
                </div>
                <ul className="pagination my-5">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage - 1)}
                    >
                      Previous
                    </button>
                  </li>
                  {getPageNumbers().map((pageNumber, index) => (
                    <li
                      key={index}
                      className={`page-item ${currentPage === pageNumber ? 'active' : ''
                        }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => {
                          if (typeof pageNumber === 'number') {
                            handlePageChange(pageNumber);
                          }
                        }}
                      >
                        {pageNumber}
                      </button>
                    </li>
                  ))}
                  <li
                    className={`page-item ${currentPage === totalPages ? 'disabled' : ''
                      }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage + 1)}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
    
        </> 
      );
    };

export default AllProjectCategoriesLogs;

